import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiInvoiceTextClockOutline } from "@mdi/js";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { Menu } from "./Menu";

export const DeliverySchedulesMenu: React.FC<Menu> = memo(
  ({ handleClick, leftMenuOpen, user }) => {
    const { t } = useTranslation();

    if (!user.roles_names.includes("Delivery Schedule - View")) {
      return null;
    }

    return (
      <HybridRouteListItemButtonLink
        caption="delivery schedules"
        name="deliverySchedules"
        onClick={() => handleClick("deliverySchedules")}
        title={t("menu.deliverySchedules.title")}
        url="/delivery_schedules"
      >
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <Icon icon={mdiInvoiceTextClockOutline} />
        </ListItemIcon>
        {!!leftMenuOpen && (
          <ListItemText
            primary={t("menu.deliverySchedules.title")}
            slotProps={{
              primary: {
                sx: {
                  fontSize: 14,
                },
              },
            }}
            sx={{ whiteSpace: "normal" }}
          />
        )}
      </HybridRouteListItemButtonLink>
    );
  },
);
